module.exports = __webpack_public_path__ + "static/media/400293_01.6f4c1b39.png";